export default {
  date: 'MM/dd/yyyy',
  // date_iso: 'yyyy-MM-dd',
  // date_long: 'dd MMMM yyyy',
  date_short: 'MMM d',
  date_with_year: 'MMM d, yyyy',
  date_time: 'MM/dd/yyyy hh:mm a',
  date_time_long: 'MMM dd yyyy HH:mm',
  date_time_us: 'MMM dd yyyy hh:mm a',
  // date_time_with_day: 'EEE, MM/dd/yyyy hh:mm a',
  // date_time_timezone: 'MM/dd/yyyy hh:mm a x',
  // time: 'hh:mm a',
  // time_iso: 'HH:mm',
  // weekday: 'EEEE',
  // countdown: 'mm:ss',
  database: 'yyyy-MM-dd',
  datepicker_date_long: 'LLLL d, yyyy',
  month_day: 'M/d',
  only_time_zone: 'z',
}
